import { Alpha } from "./alpha";
import { Beta } from "./beta";
import { Gamma } from "./gamma";
import { Delta } from "./delta";
import { Wireframe } from "./wireframe";

export const ZilchPresets = {
  Alpha,
  Beta,
  Gamma,
  Delta,
  Wireframe,
};
